import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/tracker';
import { captureAttributionIfFirstTouch } from '../lib/attribution';

/**
 * Fires a pageview log on every route change. Mounted once inside the
 * BrowserRouter so it runs across the whole app. Backend silently
 * ignores tracking from bots and authenticated admin/builder routes
 * are still fine to log — they're aggregated by URL path so the admin
 * tab can also see internal usage.
 *
 * Also captures FIRST-TOUCH acquisition attribution (UTM + referrer)
 * into session/localStorage so Signup.js can stamp it on the new
 * `users` row. This powers Pro-account attribution in Admin > Traffic
 * & Revenue.
 */
export default function PageviewTracker() {
  const { pathname, search } = useLocation();
  const apiBase = process.env.REACT_APP_BACKEND_URL;
  useEffect(() => {
    captureAttributionIfFirstTouch();
    if (!apiBase) return; // env not yet hydrated → skip
    trackPageview(apiBase);
  }, [pathname, search, apiBase]);
  return null;
}
